module.exports = "<div class=\"video push-10\" *ngIf=\"!isS3VideoFileURL\">\r\n  <iframe [src]=\"getEmbedUrl(videoURL)\" webkitallowfullscreen mozallowfullscreen allowfullscreen\r\n          style=\"height:320px; width: 100%;\"></iframe>\r\n</div>\r\n<div class=\"video push-10\" *ngIf=\"isS3VideoFileURL\">\r\n  <video style=\"height:320px; width: 100%;\" controls (click)=\"toggleVideo()\" [src]=\"videoURL\" #videoPlayer>\r\n    Browser not supported\r\n  </video>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/video-modal/video-modal.component.html
// module id = ./src/app/shared/components/video-modal/video-modal.component.html
// module chunks = main